import React from 'react';
import EditDialog from './edit';
import StepsDialog from './editSteps';


export default function EditWizard({open, handleClose=()=>{}, procedureID})
{
    const [procDialogOpen, setProcDialogOpen] = React.useState(false);
    const [stepsDialogOpen, setStepsDialogOpen] = React.useState(false);

    React.useEffect(() => {
        if(!open)
        {
            setProcDialogOpen(false)
            setStepsDialogOpen(false);
        }
        else
        {
            if(!procDialogOpen && !stepsDialogOpen)
            {
                setProcDialogOpen(true);
            }
        }
    }, [open, procDialogOpen, stepsDialogOpen]);

    const handleConfirmProcedure = () => {
        setStepsDialogOpen(true);
        setProcDialogOpen(false);
    }

    const handleGoBack = () => {
        setStepsDialogOpen(false);
        setProcDialogOpen(true);
    }

    const handleFullClose = () => {
        handleClose();
    }

    if(!procedureID) return null;

    return <>
    <EditDialog open={procDialogOpen} handleClose={handleFullClose} handleConfirm={handleConfirmProcedure} procedureID={procedureID}/>
    <StepsDialog open={stepsDialogOpen} handleClose={handleFullClose} onCancel={handleGoBack} onConfirm={handleFullClose} procedureID={procedureID} skipStepContext/>
    </>
}